/** The in-app pages a login link may send the person to afterwards. */
export type NextTarget =
  | { kind: "claim" }
  | { kind: "applications"; brandId: string; campaignId: string }
  | { kind: "agentChat"; brandId: string; sessionId: string }
  | { kind: "contentApprovals"; brandId: string };

const CLAIM_PATH = "/start/claim";
const APPLICATIONS_PATH = /^\/app\/(\d+)\/campaign\/(\d+)\/applications$/;
const AGENT_CHAT_PATH = /^\/app\/(\d+)\/campaign\/ai\?sessionId=(\d+)$/;
const CONTENT_APPROVALS_PATH = /^\/app\/(\d+)\/contentApprovals$/;

/**
 * Reads a `next` param against the exact paths a login link is allowed to open —
 * anything else (other paths, queries, absolute URLs) is null, so the param can never
 * become an open redirect.
 */
export const parseNextPath = (
  next: string | string[] | null | undefined,
): NextTarget | null => {
  const path = Array.isArray(next) ? next[0] : next;
  if (!path) return null;
  if (path === CLAIM_PATH) return { kind: "claim" };
  const applications = APPLICATIONS_PATH.exec(path);
  if (applications?.[1] && applications[2]) {
    return {
      kind: "applications",
      brandId: applications[1],
      campaignId: applications[2],
    };
  }
  const chat = AGENT_CHAT_PATH.exec(path);
  if (chat?.[1] && chat[2]) {
    return { kind: "agentChat", brandId: chat[1], sessionId: chat[2] };
  }
  const approvals = CONTENT_APPROVALS_PATH.exec(path);
  if (approvals?.[1]) {
    return { kind: "contentApprovals", brandId: approvals[1] };
  }
  return null;
};
